function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);} /* eslint-disable comma-spacing */
/* eslint-disable react/no-multi-comp */
import React, { useContext } from 'react';
import {
  useLocation,
  useMatches,
  useNavigate,
  useOutlet,
  useParams,
  useSearchParams } from
'react-router-dom';
import { AppMainContext } from "./App/AppMainContext";
import { searchParamsFromSearchParams } from "./utils/routeHelpers";

const withRouter =
(Component) =>
(props) => {var _props$params;
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const matches = useMatches();
  const [searchParams, setSearchParams] = useSearchParams();
  const { q: searchString } = searchParamsFromSearchParams(searchParams);
  const paramsFromProps = _objectSpread(_objectSpread({}, props.params), {}, { q: searchString || ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.q) });

  return /*#__PURE__*/(
    React.createElement(Component, _extends({},
    props, {
      navigate: navigate,
      location: location,
      params: _objectSpread(_objectSpread({}, params), paramsFromProps || {}),
      matches: matches,
      searchParams: searchParams,
      setSearchParams: setSearchParams })
    ));

};

const withContext =
(Component) =>
(props) => {
  const mainContext = useContext(AppMainContext);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, { mainContext: mainContext }));
};

const withOutlet =
(Component) =>
(props) => {
  const outlet = useOutlet(AppMainContext);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, { outlet: outlet }));
};
export { withRouter, withContext, withOutlet };